// extracted by mini-css-extract-plugin
export default {"skillsContainer":"skills_skillsContainer__nYA7m","container":"skills_container__wXpBT","skillChiled":"skills_skillChiled__IDWPM","skillafter":"skills_skillafter__2hbWE"};